import React from "react";
import "../styles/CollaboSection.css";

const IdeaSection = () => {

    // Function to handle the button click and open the email client
    const handleEmailClick = () => {
        window.location.href = 'mailto:fr.ajuluchukwu@gmail.com'; // This will open the default email client
    };

    return (
        <div className="idea-section">
            {/* Background with faded templates */}
            <div className="project-bg">
                <div className="project-item">Project 1</div>
                <div className="project-item">Project 2</div>
                <div className="project-item">Your Project could be here</div>
                <div className="project-item">Project 2</div>
                <div className="project-item">Project 3</div>
                <div className="project-item">Project 4</div>
                <div className="project-item">Your Project could be here</div>
                <div className="project-item">Project 4</div>
                <div className="project-item">Project 5</div>
                <div className="project-item">Your Project could be here</div>
                <div className="project-item">Project 4</div>
                <div className="project-item">Project 5</div>
            </div>

            {/* Main content */}
            <div className="idea-content">
                <h1>
                    Got an idea, <br/> you'd like to share?
                </h1>
                <p>
                    Let's create something.
                </p>
                <div className="footer-box">
                <a href="#mailto:fr.ajuluchukwu@gmail.com" className="cta-button-footer" onClick={handleEmailClick}>Drop a message</a>
            </div>
            </div>
        </div>
    );
};

export default IdeaSection;